import classNames from 'classnames';

import Blocks from './Blocks';

import styles from '../../styles/blocks/section-block.module.css';

interface SectionBlockProps {
    blocks: Block[];
    className?: string | null;
}

function SectionBlock({ blocks, className = null }: SectionBlockProps) {
    return <Blocks blocks={blocks} className={classNames([styles.container, className])} />;
}

export default SectionBlock;
